import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SidebarState = {
    /** Maps group title -> open/closed state */
    expandedGroups: Record<string, boolean>;

    toggleGroup: (groupTitle: string) => void;
    setGroupOpen: (groupTitle: string, isOpen: boolean) => void;
    isGroupOpen: (groupTitle: string, fallback: boolean) => boolean;
};

export const useSidebarStore = create<SidebarState>()(
    persist(
        (set, get) => ({
            expandedGroups: {},

            toggleGroup: (groupTitle) =>
                set((state) => ({
                    expandedGroups: {
                        ...state.expandedGroups,
                        [groupTitle]: !state.expandedGroups[groupTitle],
                    },
                })),

            setGroupOpen: (groupTitle, isOpen) =>
                set((state) => ({
                    expandedGroups: {
                        ...state.expandedGroups,
                        [groupTitle]: isOpen,
                    },
                })),

            isGroupOpen: (groupTitle, fallback) => {
                const stored = get().expandedGroups[groupTitle];
                return stored !== undefined ? stored : fallback;
            },
        }),
        {
            name: 'sidebar-expanded-groups',
        }
    )
);
